function closest(el, selector) {
    const found = el.closest(selector);
    if (found)
        return found;
    const root = el.getRootNode();
    if (isShadowRoot(root)) {
        return closest(root.host, selector);
    }
    return null;
}
const isShadowRoot = (node) => {
    return node.nodeType === node.DOCUMENT_FRAGMENT_NODE;
};
const findMatches = (elements, selector, pierce) => {
    const matches = [];
    for (const $el of elements) {
        if ($el.matches(selector)) {
            matches.push($el);
        }
        if (!pierce)
            continue;
        if ($el.shadowRoot) {
            matches.push(...piercingQuerySelectorAll($el.shadowRoot, selector));
        }
        if ($el.nodeName === 'SLOT') {
            matches.push(...slottedQuerySelectorAll($el, selector));
        }
    }
    return matches;
};
/**
 * Searches for a (simple) selector throughout the shadow dow
 */
const piercingQuerySelectorAll = (
/** The root element to search in */
root, 
/** The selector to search for */
selector) => findMatches(Array.from(root.querySelectorAll('*')), selector, true);
/**
 * Searches slotted elements for matching
 */
const slottedQuerySelectorAll = (
/** The slot to search in */
$slot, 
/** The selector to match */
selector, 
/** If we should pierce through the shadow dom of slotted elements */
pierce = true) => findMatches($slot.assignedElements(), selector, pierce);

export { closest, piercingQuerySelectorAll, slottedQuerySelectorAll };
